import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiExError } from '@shared';

export interface AiUnderwritingTypeformData {
  client: TypeformPayload | null;
  partner: TypeformPayload | null;
}
export interface AiUnderwritingTypeformState {
    data: {
      client: TypeformPayload | null;
      partner: TypeformPayload | null;
    };
    isLoading: {
      client: boolean;
      partner: boolean;
    };
    error: {
      client: string | null;
      partner: string | null;
    };
  }

  const initialState: AiUnderwritingTypeformState = {
    data: {
      client: null,
      partner: null,
    },
    isLoading: {
      client: false,
      partner: false,
    },
    error: {
      client: null,
      partner: null,
    },
  };

  // Cleaner action payloads
  export interface FetchAiUnderwritingTypeformPayload {
    clientId: string;
    target: 'client' | 'partner';
  }


const aiUnderwritingTypeformSlice = createSlice({
    name: 'aiUnderwritingTypeform',
    initialState,
    reducers: {
      postAiTypeformPayloadByClientIdRequest(
        state, 
        action: PayloadAction<FetchAiUnderwritingTypeformPayload>
      ) {
        const { target } = action.payload;
        state.isLoading[target] = true;
        state.error[target] = null;
      },

      postAiTypeformPayloadByClientIdResponse(
        state,
        action: PayloadAction<TypeformPayload & { target: 'client' | 'partner' }>
      ) {
        if (action.payload) {
          const target = action.payload.target || 'client';
          state.data[target] = action.payload;
          state.isLoading[target] = false;
          state.error[target] = null;
        }
      },

      postAiTypeformPayloadByClientIdFailure(
        state, 
        action: PayloadAction<ApiExError>
      ) {
        
        state.isLoading.client = false;
        state.isLoading.partner = false;
        state.error.client = action.payload.message || 'Failed to fetch typeform payload';
      },

      resetAiUnderwritingTypeformState() {
        return initialState;
      },
  },
});

export const {
  postAiTypeformPayloadByClientIdRequest,
  postAiTypeformPayloadByClientIdResponse,
  postAiTypeformPayloadByClientIdFailure,
  resetAiUnderwritingTypeformState,
} = aiUnderwritingTypeformSlice.actions;

export const aiUnderwritingTypeformReducer = aiUnderwritingTypeformSlice.reducer;
